import _regeneratorRuntime from '/var/www/html/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/var/www/html/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery';
import axios from 'axios';
export default {
    layout: function layout(context) {
        return global.getTheme();
    },
    data: function data() {
        return {
            staticPage: {}
        };
    },
    mounted: function mounted() {},
    asyncData: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                route = _ref.route;

            var _ref3, data;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return axios.get(global.getEndPoint() + 'api/static-page/' + route.params.slug);

                        case 2:
                            _ref3 = _context.sent;
                            data = _ref3.data;
                            return _context.abrupt('return', {
                                staticPage: data.page
                            });

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function asyncData(_x) {
            return _ref2.apply(this, arguments);
        }

        return asyncData;
    }(),
    created: function created() {
        this.website = this.$root.trans(global.websiteSettings.extra_info.title);
    },
    head: function head() {
        return {
            titleTemplate: this.getTitle(),
            meta: [{ hid: 'description', name: 'description', content: this.getDescription() }, { hid: 'keywords', name: 'keywords', content: this.getKeywords() }, { hid: 'og:description', name: 'og:description', content: this.getDescription() }, { hid: 'og:title', name: 'og:title', content: this.getTitle() }]
        };
    },

    methods: {
        getTitle: function getTitle() {
            return this.$root.trans('st_public.static_page', this.$root._route.params.lang) + ' - ' + this.$root.trans(global.websiteSettings.extra_info.title);
        },
        getDescription: function getDescription() {
            return this.$root.trans('st_public.static_page_meta_tags', { website: this.$root.trans(global.websiteSettings.extra_info.title) });
        },
        getKeywords: function getKeywords() {
            return this.$root.trans(global.websiteSettings.extra_info.title) + ', ' + this.$root.trans('st_public.static_page', this.$root._route.params.lang);
        },
        getAllCookies: function getAllCookies() {
            if (process.client) {
                return document.cookie;
            }
            return '';
        },
        refreshLoggedUser: function refreshLoggedUser() {
            this.$auth.getUser(function (user) {
                this.loggedUser = user;
            }.bind(this));
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/page/_slug.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/page/_slug.vue
// module chunks = 19